// src/components/AddNoteModal.tsx
import React from 'react'
import Modal from '../../../components/UI/UIModal'
import { Icon } from '../../../components/Icon'
import UITextArea from '../../../components/UI/UITextArea'
import UIButton from '../../../components/UI/UIButton'
import UITextInput from '../../../components/UI/UITextInput'

interface AddNoteModalProps {
  isOpen: boolean
  onClose: () => void
  notesDetail: string
  notesTitle: string
  setNotesTitle: (value: string) => void
  setNotesDetail: (value: string) => void
  addNote: () => Promise<void>
  loading: boolean
}

const AddNoteModal: React.FC<AddNoteModalProps> = ({
  isOpen,
  onClose,
  notesTitle,
  setNotesTitle,
  notesDetail,
  setNotesDetail,
  addNote,
  loading,
}) => {
  return (
    <Modal
      customStyle={{
        borderRadius: 16,
        padding: '20px 16px',
        width: '480px',
      }}
      isOpen={isOpen}
      onClose={onClose}
    >
      <div
        className={
          'max-h-[80vh] min-h-[45vh] items-center p-4 flex flex-col gap-4'
        }
      >
        <div
          onClick={onClose}
          className="flex w-[100%] justify-end cursor-pointer"
        >
          <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
        </div>
        <div className="flex items-center w-[100%] justify-center">
          <Icon
            name={'IconStickerSquare'}
            stroke={'#02698C'}
            strokeWidth={0.5}
            height={56}
            width={56}
          />
        </div>
        <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
          <h1 className={'text-text2 text-lg font-bold leading-6'}>
            {'Add Note'}
          </h1>
          <p className={'text-sm leading-5 text-text1 font-normal'}>
            {' Please enter the details about this note'}
          </p>
        </div>
        <div className="w-full flex-col flex gap-4 mt-3">
          <div>
            <UITextInput
              iconName=""
              label="Title*"
              placeholder="title"
              onChange={(e) => {
                setNotesTitle(e.target.value)
              }}
              value={notesTitle}
            />
          </div>
          <div>
            <UITextArea
              label="Note Details*"
              placeholder="Write Note Details here"
              rows={7}
              value={notesDetail}
              onChange={(e) => setNotesDetail(e.target.value)}
            />
          </div>
        </div>
        <div className="w-full mt-4">
          <UIButton
            disabled={notesDetail === ''}
            loading={loading}
            onClick={addNote}
            label={'Add'}
          />
        </div>
      </div>
    </Modal>
  )
}

export default AddNoteModal
